import type { EditorInput } from "@/components/Form/ComplexMarkdownField/types";
import type { NodeOption } from "./variableOptions";

export function nodeOptionsToEditorInputs(
  options: NodeOption[]
): EditorInput[] {
  const inputs: EditorInput[] = [];
  for (const node of options) {
    for (const output of node.outputs) {
      inputs.push({
        id: output.value,
        name: output.outputLabel,
        dataType: output.dataType,
        isList: output.isList,
        compatibility: output.compatibility,
        sourceNodeId: node.nodeId,
        sourceName: node.nodeName,
        sourceImage: node.nodeImage ?? undefined,
        sourceIconName: node.nodeIconName,
        sourceColor: node.nodeColor,
        sourceOutput: output.outputLabel,
        sourceKind: "node",
        scope: output.scope,
      });
    }
  }
  return inputs;
}
